// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};
export const PACKAGE_STATUS = {
  PICKED: 237,
};

export const ROLES = {
  ADMIN_PICKER_ROLE: "ADMIN_PICKER_ROLE",
  PICKER_ROLE: "PICKER_ROLE",
  TO_PICKER_ROLE: "TO_PICKER_ROLE",
  CHECKER_ROLE: "CHECKER_ROLE",
  TO_CHECKER_ROLE: "TO_CHECKER_ROLE",
  ADMIN_CHECKER_ROLE: "ADMIN_CHECKER_ROLE",
  PACKER_ROLE: "PACKER_ROLE",
  ADMIN_PACKER_ROLE: "ADMIN_PACKER_ROLE",
  DISPATCH_ROLE: "DISPATCH_ROLE",
  TO_DISPATCH_ROLE: "TO_DISPATCH_ROLE",
  SUPERADMIN: "SUPERADMIN",
  BIN_TRANSFER: "BIN_TO_BIN_MOVEMENT",
  PUT_AWAY_ROLE: "PUT_AWAY_MOVEMENT",
  TO_PACKER_ROLE: "TO_PACKER_ROLE",
};

export const CURRENT_BOX = "currentBox";

// ----------------- Portal Envs

export const ENV_VARIABLES = {
  PRODUCTION: 1,
  STAGE: 2,
  STAGE_MUM: 3,
  STAGE_ANDROID: 4,
  UAT: 5,
  STAGE_QA: 6,
};

// ----------------- Portal Warehouse lists

export const TM_WAREHOUSES = {
  MUMBAI: 10,
  MUMBAI_OLD: 3,
  DELHI: 9,
  DELHI_OLD: 5,
  LUCKNOW: 8,
  KOLKATA: 12,
  KOLKATA_OLD: 7,
  BANGLORE: 6,
  FARIDABAD: 11,
  FARIDABAD_ANKW: 21,
  AHMEDABAD: 13,
};

// ------------------- Warehouse ID & ENV setup -------------------

export const warehouseId = +(
  process.env.REACT_APP_CURRENT_WAREHOUSE || TM_WAREHOUSES.FARIDABAD
);

export const currentEnv = +(
  process.env.REACT_APP_CURRENT_ENV || ENV_VARIABLES.PRODUCTION
);

export const API_TYPE = {
  NEW: 1,
  OLD: 2,
};

export const SOMETHING_WENT_WRONG = "Something went wrong";
export const INVALID_TO = "Invalid TO ID";
export const BOX_SCANNED_ALREADY = "Box already scanned";
export const BOX_DOES_NOT_EXIST_TO = "This box doesn't exists in this TO";
export const ALL_BOXES_CHECKED = "All boxes checked";
export const FILE_DOWNLOADED = "File Downloaded";
export const NEW_DELIVERY_CHARGE = {
  DELIVERY_CHARGE_TRUE: "newDeliveryCharge=true",
  DELIVERY_CHARGE_FALSE: "newDeliveryCharge=false",
};
export const REDIRECT_MESSAGE = "Please log in again.";

export const TASKID_ERR = "Please create new TaskId to proceed";
export const ALREADY_RACKED = "Already Racked";
export const SUBMITTED = "Submitted";

export const PACK_SLIP_SCREENS = {
  HOME: "HOME",
  ASSIGNED: "ASSIGNED",
};

export const BIN_SCAN_TYPES = {
  SOURCE_SCAN: 1,
  DESTINATION_SCAN: 2,
};

export const ELASTIC_SEARCHTYPE = {
  PRODUCT_CODE_SEARCH: "PRODUCT_CODE_SEARCH",
};

export const PACKSLIP_CTA_TYPE = {
  BOXFULL: 1,
  SUBMIT: 2,
};

export const WAREHOUSE_BUILD_VERSIONS = {
  [TM_WAREHOUSES.FARIDABAD]: "1.5.3",
  [TM_WAREHOUSES.FARIDABAD_ANKW]: "1.5.3",
};

export const DEFAULT_DESK = "MUM Checker D1";

export const REGEX = {
  SPECIAL_CHAR: /[^a-zA-Z0-9.-]|\s|--|-\.|\.-/,
};
